import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ReactComponent as GolferIcon } from '../../../assets/images/common/icons/golfer-half-icon.svg'
import { ReactComponent as CloseIcon } from '../../../assets/images/common/icons/modal-X-icon.svg'

import classes from './TablePlaceholder.module.scss'

const TablePlaceholder = ({ message, description, actionLabel, onAction, linkLabel, onLink }) => {
  const { t } = useTranslation()

  return (
    <div className={classes.placeholderContainer}>
      <div className='d-flex align-items-center flex-column'>
        <GolferIcon className={classes.icon} />
        <h4 className='my-3'>{message || t('common.noData')}</h4>
        {description && <p className={classes.description}>{description}</p>}
        {actionLabel && onAction && (
          <button className={classes.clearButton} onClick={onAction}>
            {actionLabel}
            <CloseIcon className={classes.clearIcon} aria-hidden='true' />
          </button>
        )}
        {linkLabel && onLink && (
          <button className={classes.link} onClick={onLink}>{linkLabel}</button>
        )}
      </div>
    </div>
  )
}

TablePlaceholder.propTypes = {
  message: PropTypes.string,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  linkLabel: PropTypes.string,
  onLink: PropTypes.func,
}

export default TablePlaceholder
